<div class="flex row justify-space-evenly">
    <div class="flex row content">
        <div class="flex row align-space-around justify-space-evenly feature-block">
            <div class="flex column">
                <a class="home" routerLink="/">
                    <img src="assets/icons/logo.png" />
                </a>
            </div>
            <div class="flex column">
                <h3>Product</h3>
                <a href="/#features">Features</a>
                <a routerLink="/privacy">Privacy</a>
                <a routerLink="/terms">Terms</a>
            </div>
            @if (!hosted) {
                <div class="flex column">
                    <h3>Pricing</h3>
                    <a routerLink="/pricing">Plans</a>
                </div>
            }
            <div class="flex column">
                <h3>Company</h3>
                <a routerLink="/contact">Contact Us</a>
            </div>
        </div>
    </div>
</div>
<div class="flex row align-center justify-center">
    <small class="copyright"
        >©2022 FrogUBD, LLC. All rights reserved. Various trademarks held by their respective
        owners.</small
    >
</div>
